import { render, staticRenderFns } from "./cus_footer.vue?vue&type=template&id=2de573ce&scoped=true"
import script from "./cus_footer.vue?vue&type=script&lang=js"
export * from "./cus_footer.vue?vue&type=script&lang=js"
import style0 from "./cus_footer.vue?vue&type=style&index=0&id=2de573ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de573ce",
  null
  
)

export default component.exports